import angular from 'angular';
import { isArray, isObject, isString, pickBy, pull } from 'lodash';

module.exports = angular.module('common.filters.features', [])
.filter('features', function() {
  return function(features, other_text) {
    let featureString = features || '';
    if (isArray(features)) {
      featureString = features.join(', ');
    } else if (isObject(features) && !isString(features)) {
      let selected_features = Object.keys(pickBy(features));

      // special case "other" to pull out actual reason, IE (other=>true, other_text=>"dragons")
      if (features.other) {
        pull(selected_features, "other");
        selected_features.push(other_text || "other (unspecified)");
      }

      featureString = selected_features.join(', ');
    }
    return featureString.replace(/_/g, ' ');
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/features.js
 **/